<main>

    <div class="header-section">
        <h1>Resumo do Dia</h1>
    </div>

    <div class="cards-sobre-pedidos">

        <div class="cards container">
            <mat-card id="pedidos" [routerLink]="'pedidos'">
                <div class="header-card">
                    <mat-icon fontSet="material-icons-outlined">article</mat-icon>
                    <mat-card-title>{{ kanbamService.getQuantidadePedidosPorTipoFiltro('TODOS') }}</mat-card-title>
                </div>
                <div class="body-card">
                    <mat-card-subtitle>Pedidos</mat-card-subtitle>
                </div>
            </mat-card>

            <mat-card id="delivery" [routerLink]="'pedidos'">
                <div class="header-card">
                    <mat-icon fontSet="material-icons-outlined">sports_motorsports</mat-icon>
                    <mat-card-title>{{kanbamService.getQuantidadePedidosPorTipoFiltro('DELIVERY')}}</mat-card-title>
                </div>
                <div class="body-card">
                    <mat-card-subtitle>Delivery</mat-card-subtitle>
                </div>
            </mat-card>
        </div>

        <div class="cards container" [routerLink]="'pedidos'">
            <mat-card id="retirada">
                <div class="header-card">
                    <mat-icon fontSet="material-icons-outlined">storefront</mat-icon>
                    <mat-card-title>{{ kanbamService.getQuantidadePedidosPorTipoFiltro('RETIRADA') }}</mat-card-title>
                </div>
                <div class="body-card">
                    <mat-card-subtitle>Retiradas</mat-card-subtitle>
                </div>
            </mat-card>

            <mat-card id="consumo" [routerLink]="'pedidos'">
                <div class="header-card">
                    <mat-icon fontSet="material-icons-outlined">restaurant</mat-icon>
                    <mat-card-title>{{ kanbamService.getQuantidadePedidosPorTipoFiltro('CONSUMO') }}</mat-card-title>
                </div>
                <div class="body-card">
                    <mat-card-subtitle>Consumo</mat-card-subtitle>
                </div>
            </mat-card>
        </div>
    </div>

    <section id="horarios">
        <div>
            <div>
                <h1>Horários de funcionamento</h1>
                <hr>
                <table>
                    <tr *ngFor="let dia of authService.usuario.Horarios">
                        <td width="120">{{dia.Dia}}</td>
                        <td width="100" *ngFor="let horario of dia.Horario">{{horario.de}} às {{horario.ate}}</td>
                    </tr>
                </table>
            </div>
        </div>
    </section>

    <!-- <section id="horario-funcionamento">
        <div>
            <h1>Horário de funcionamento hoje</h1>
            <hr>
            <p>Segunda-feira: 08:00 - 20:00</p>
            <p>Terça-feira: 08:00 - 20:00</p>
        </div>
        
    </section> -->


    <!-- <div class="cards-noticias">
        <div [innerHtml]="informacoes | safeHtml"></div>
    </div> -->


</main>
<!-- <div class="cards-noticias">
    <mat-card>
        <img src="https://static-images.ifood.com.br/image/upload/t_high,q_100/webapp/landing/landing-banner-3.png" alt="">
    </mat-card>

    <mat-card>
        <img src="https://static-images.ifood.com.br/image/upload/t_high,q_100/webapp/landing/landing-banner-2.png" alt="">
    </mat-card>

    <mat-card>
        <img src="https://static-images.ifood.com.br/image/upload/t_high,q_100/webapp/landing/landing-banner-1.png" alt="">
    </mat-card>
<div class="cards-noticias">
    <div [innerHtml]="informacoes | safeHtml"></div>
</div> -->